import { useEffect } from "react";

import { useAddFiles } from "@/agent/chat/useAddFiles";
import { useThreadId } from "@/agent/chat/useThreadId";

import { clearLipDocument, useLipDocument } from "./lipStore";

/**
 * Attaches the document a page's "Add to chat" handed to the lip (``addToLip``), by reference, as a
 * drop on the lip does: once the lip's thread is known. `onAdding` then takes the focus into the
 * lip (the button that opened it is on the page). Mount it inside the lip's AgentRuntime.
 */
export function LipAddDocument({ onAdding }: { onAdding?: () => void }) {
  const document = useLipDocument();
  const threadId = useThreadId();
  const { addDocument } = useAddFiles();
  useEffect(() => {
    if (!document || threadId == null) return;
    clearLipDocument();
    onAdding?.();
    void addDocument(document);
  }, [document, threadId, addDocument, onAdding]);
  return null;
}
